var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 201,
    viewBox: "0 0 160 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1940)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650635,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.528 159.651V148.931H16.8V159.651H18.528ZM21.8561 159.651V155.715C21.8561 153.987 22.6401 153.091 24.3841 153.091C26.0321 153.091 26.7041 153.843 26.7041 155.331V159.651H28.4321V154.867C28.4321 153.027 27.3441 151.539 25.1361 151.539C23.1201 151.539 22.0641 152.819 21.8241 154.163H21.7121V151.699H20.1281V159.651H21.8561ZM33.9879 159.811C36.3719 159.811 38.1159 158.467 38.1159 156.483V156.307H36.4039V156.419C36.4039 157.651 35.5079 158.259 33.9559 158.259C32.1639 158.259 31.3639 157.395 31.3639 155.683C31.3639 153.939 32.1639 153.091 33.9559 153.091C35.5079 153.091 36.4039 153.699 36.4039 154.931V155.027H38.1159V154.867C38.1159 152.883 36.3719 151.539 33.9879 151.539C31.3639 151.539 29.6519 153.203 29.6519 155.683C29.6519 158.131 31.3639 159.811 33.9879 159.811ZM43.3938 159.811C45.7618 159.811 47.4258 158.643 47.4258 156.947V156.803H45.6978V156.931C45.6978 157.875 45.0098 158.419 43.3458 158.419C41.5058 158.419 40.7538 157.603 40.6898 156.067H47.4418C47.4898 155.827 47.5058 155.603 47.5058 155.315C47.5058 152.899 45.8258 151.539 43.3618 151.539C40.7698 151.539 39.0738 153.203 39.0738 155.683C39.0738 158.339 40.7858 159.811 43.3938 159.811ZM43.3298 152.899C45.0258 152.899 45.8738 153.603 45.8738 155.075V155.107H40.7057C40.8018 153.683 41.5698 152.899 43.3298 152.899ZM50.528 159.651V155.715C50.528 153.987 51.312 153.091 53.056 153.091C54.704 153.091 55.376 153.843 55.376 155.331V159.651H57.104V154.867C57.104 153.027 56.016 151.539 53.808 151.539C51.792 151.539 50.736 152.819 50.496 154.163H50.384V151.699H48.8V159.651H50.528ZM63.8598 159.651V158.099H62.4198C61.4278 158.099 60.9798 157.843 60.9798 156.867V153.139H63.8598V151.699H60.9798V149.955H59.2678V151.699H57.9238V153.139H59.2678V156.963C59.2678 158.899 60.3238 159.651 62.0358 159.651H63.8598ZM66.6686 150.771V148.931H64.9406V150.771H66.6686ZM66.6686 159.651V151.699H64.9406V159.651H66.6686ZM73.3728 159.651L77.1168 151.699H75.2448L72.4128 157.971H72.2848L69.4528 151.699H67.5488L71.2608 159.651H73.3728ZM82.0031 159.811C84.3711 159.811 86.0351 158.643 86.0351 156.947V156.803H84.3071V156.931C84.3071 157.875 83.6191 158.419 81.9551 158.419C80.1151 158.419 79.3631 157.603 79.2991 156.067H86.0511C86.0991 155.827 86.1151 155.603 86.1151 155.315C86.1151 152.899 84.4351 151.539 81.9711 151.539C79.3791 151.539 77.6831 153.203 77.6831 155.683C77.6831 158.339 79.3951 159.811 82.0031 159.811ZM81.9391 152.899C83.6351 152.899 84.4831 153.603 84.4831 155.075V155.107H79.3151C79.4111 153.683 80.1791 152.899 81.9391 152.899ZM91.1694 159.811C93.4094 159.811 94.8814 158.931 94.8814 157.443C94.8814 156.131 94.0174 155.491 92.1294 155.251L90.2894 154.995C89.0894 154.835 88.7694 154.611 88.7694 153.987C88.7694 153.235 89.2814 152.915 90.7374 152.915C92.4974 152.915 92.9774 153.411 92.9774 154.355V154.451H94.6894V154.403C94.6894 152.515 93.2174 151.539 90.7854 151.539C88.3374 151.539 87.0734 152.531 87.0734 153.923C87.0734 155.251 87.9854 155.891 89.4894 156.083L91.6654 156.371C92.8014 156.531 93.1854 156.739 93.1854 157.395C93.1854 158.099 92.7214 158.419 91.1694 158.419C89.5054 158.419 88.8814 158.083 88.8814 157.043V156.915H87.1534V156.963C87.1534 158.803 88.6094 159.811 91.1694 159.811ZM101.199 159.811C103.007 159.811 104.271 159.011 104.687 157.667H104.799V159.651H106.383V154.819C106.383 152.915 105.247 151.539 102.719 151.539C100.191 151.539 98.6865 152.899 98.6865 154.707V154.771H100.399V154.707C100.399 153.539 101.119 153.059 102.591 153.059C104.111 153.059 104.687 153.523 104.687 154.835V155.299L101.071 155.683C99.5025 155.859 98.5105 156.499 98.5105 157.731C98.5105 159.043 99.5505 159.811 101.199 159.811ZM100.239 157.619C100.239 156.995 100.671 156.787 101.567 156.675L104.687 156.323C104.687 157.891 103.471 158.563 101.663 158.563C100.671 158.563 100.239 158.259 100.239 157.619ZM109.653 159.651V155.715C109.653 153.987 110.437 153.091 112.181 153.091C113.829 153.091 114.501 153.843 114.501 155.331V159.651H116.229V154.867C116.229 153.027 115.141 151.539 112.933 151.539C110.917 151.539 109.861 152.819 109.621 154.163H109.509V151.699H107.925V159.651H109.653ZM121.273 159.811C123.065 159.811 124.233 158.947 124.569 157.363H124.681V159.651H126.265V148.931H124.537V153.859H124.441C124.121 152.515 123.049 151.539 121.161 151.539C118.745 151.539 117.369 153.203 117.369 155.683C117.369 158.131 118.761 159.811 121.273 159.811ZM119.113 155.683C119.113 153.763 120.105 153.107 121.769 153.107C123.545 153.107 124.537 153.939 124.537 155.635V155.763C124.537 157.427 123.497 158.227 121.801 158.227C120.089 158.227 119.113 157.587 119.113 155.683ZM18.384 179.651V177.363H18.496C18.832 178.947 20 179.811 21.808 179.811C24.336 179.811 25.696 178.131 25.696 175.683C25.696 173.203 24.352 171.539 21.904 171.539C20 171.539 18.944 172.515 18.624 173.859H18.528V168.931H16.8V179.651H18.384ZM18.528 175.763V175.635C18.528 173.939 19.504 173.107 21.296 173.107C22.992 173.107 23.968 173.763 23.968 175.683C23.968 177.587 23.008 178.227 21.264 178.227C19.552 178.227 18.528 177.427 18.528 175.763ZM30.9578 179.811C33.6138 179.811 35.3898 178.131 35.3898 175.683C35.3898 173.203 33.6138 171.539 30.9578 171.539C28.3178 171.539 26.5418 173.203 26.5418 175.683C26.5418 178.131 28.3178 179.811 30.9578 179.811ZM30.9578 178.275C29.0378 178.275 28.2378 177.363 28.2378 175.683C28.2378 173.987 29.0378 173.059 30.9578 173.059C32.8938 173.059 33.6938 173.987 33.6938 175.683C33.6938 177.363 32.8938 178.275 30.9578 178.275ZM38.3718 179.651V175.715C38.3718 173.987 39.1558 173.091 40.8998 173.091C42.5478 173.091 43.2198 173.843 43.2198 175.331V179.651H44.9478V174.867C44.9478 173.027 43.8598 171.539 41.6518 171.539C39.6358 171.539 38.5798 172.819 38.3398 174.163H38.2278V171.699H36.6438V179.651H38.3718ZM49.7995 179.811C51.8475 179.811 52.9035 178.531 53.1595 177.187H53.2555V179.651H54.8395V171.699H53.1275V175.635C53.1275 177.363 52.3115 178.259 50.5515 178.259C48.8715 178.259 48.1835 177.507 48.1835 176.019V171.699H46.4715V176.483C46.4715 178.323 47.5595 179.811 49.7995 179.811ZM60.1694 179.811C62.4094 179.811 63.8814 178.931 63.8814 177.443C63.8814 176.131 63.0174 175.491 61.1294 175.251L59.2894 174.995C58.0894 174.835 57.7694 174.611 57.7694 173.987C57.7694 173.235 58.2814 172.915 59.7374 172.915C61.4974 172.915 61.9774 173.411 61.9774 174.355V174.451H63.6894V174.403C63.6894 172.515 62.2174 171.539 59.7854 171.539C57.3374 171.539 56.0734 172.531 56.0734 173.923C56.0734 175.251 56.9854 175.891 58.4894 176.083L60.6654 176.371C61.8014 176.531 62.1854 176.739 62.1854 177.395C62.1854 178.099 61.7214 178.419 60.1694 178.419C58.5054 178.419 57.8814 178.083 57.8814 177.043V176.915H56.1534V176.963C56.1534 178.803 57.6094 179.811 60.1694 179.811ZM69.1281 179.811C71.4961 179.811 73.1601 178.643 73.1601 176.947V176.803H71.4321V176.931C71.4321 177.875 70.7441 178.419 69.0801 178.419C67.2401 178.419 66.4881 177.603 66.4241 176.067H73.1761C73.2241 175.827 73.2401 175.603 73.2401 175.315C73.2401 172.899 71.5601 171.539 69.0961 171.539C66.5041 171.539 64.8081 173.203 64.8081 175.683C64.8081 178.339 66.5201 179.811 69.1281 179.811ZM69.0641 172.899C70.7601 172.899 71.6081 173.603 71.6081 175.075V175.107H66.4401C66.5361 173.683 67.3041 172.899 69.0641 172.899ZM78.2944 179.811C80.5344 179.811 82.0064 178.931 82.0064 177.443C82.0064 176.131 81.1424 175.491 79.2544 175.251L77.4144 174.995C76.2144 174.835 75.8944 174.611 75.8944 173.987C75.8944 173.235 76.4064 172.915 77.8624 172.915C79.6224 172.915 80.1024 173.411 80.1024 174.355V174.451H81.8144V174.403C81.8144 172.515 80.3424 171.539 77.9104 171.539C75.4624 171.539 74.1984 172.531 74.1984 173.923C74.1984 175.251 75.1104 175.891 76.6144 176.083L78.7904 176.371C79.9264 176.531 80.3104 176.739 80.3104 177.395C80.3104 178.099 79.8464 178.419 78.2944 178.419C76.6304 178.419 76.0064 178.083 76.0064 177.043V176.915H74.2784V176.963C74.2784 178.803 75.7344 179.811 78.2944 179.811ZM85.1091 179.651V177.171H82.9331V179.651H85.1091Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24.5205,
    y1: 104.983,
    x2: 24.5205,
    y2: -36.5318,
    stroke: "url(#paint0_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5205,
    y1: 104.983,
    x2: 60.5205,
    y2: -36.5318,
    stroke: "url(#paint1_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5205,
    y1: 104.983,
    x2: 96.5205,
    y2: -36.5318,
    stroke: "url(#paint2_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.521,
    y1: 104.983,
    x2: 132.521,
    y2: -36.5318,
    stroke: "url(#paint3_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 3.84424,
    x2: 229.941,
    y2: 3.84422,
    stroke: "url(#paint4_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 62.8442,
    x2: 229.941,
    y2: 62.8442,
    stroke: "url(#paint5_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 32.8442,
    x2: 229.941,
    y2: 32.8442,
    stroke: "url(#paint6_linear_51_1940)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1940)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4062 36.7499C46.536 36.7499 45.7014 37.0956 45.0861 37.7109C44.4707 38.3263 44.125 39.1609 44.125 40.0311C44.125 40.9014 44.4707 41.736 45.0861 42.3513C45.7014 42.9667 46.536 43.3124 47.4062 43.3124H50.6875V51.1874H36.9062C36.036 51.1874 35.2014 50.8417 34.5861 50.2263C33.9707 49.611 33.625 48.7764 33.625 47.9061V46.5936C33.625 44.7806 35.095 43.3124 36.9062 43.3124H42.494C41.6432 42.0485 41.3137 40.5046 41.5744 39.0035C41.8352 37.5023 42.6659 36.16 43.8931 35.257C45.1203 34.354 46.649 33.9602 48.1597 34.1578C49.6705 34.3555 51.0464 35.1293 52 36.3176C52.9536 35.1293 54.3295 34.3555 55.8403 34.1578C57.351 33.9602 58.8797 34.354 60.1069 35.257C61.3341 36.16 62.1648 37.5023 62.4256 39.0035C62.6863 40.5046 62.3568 42.0485 61.506 43.3124H68.4062C70.2175 43.3124 71.6875 44.7824 71.6875 46.5936V47.9061C71.6875 49.7191 70.2175 51.1874 68.4062 51.1874H53.3125V43.3124H56.5938C57.2427 43.3124 57.8771 43.1199 58.4167 42.7594C58.9563 42.3988 59.3769 41.8864 59.6252 41.2868C59.8736 40.6872 59.9386 40.0275 59.812 39.391C59.6853 38.7545 59.3728 38.1698 58.9139 37.7109C58.4551 37.252 57.8704 36.9395 57.2339 36.8129C56.5974 36.6863 55.9376 36.7513 55.3381 36.9997C54.7385 37.248 54.226 37.6686 53.8655 38.2082C53.5049 38.7478 53.3125 39.3822 53.3125 40.0311V43.3124H50.6875V40.0311C50.6875 38.2181 49.2175 36.7499 47.4062 36.7499ZM50.6875 53.8124H36.25V65.6249C36.25 66.6692 36.6648 67.6707 37.4033 68.4091C38.1417 69.1475 39.1432 69.5624 40.1875 69.5624H50.6875V53.8124ZM53.3125 53.8124V69.5624H65.125C66.1693 69.5624 67.1708 69.1475 67.9092 68.4091C68.6477 67.6707 69.0625 66.6692 69.0625 65.6249V53.8124H53.3125Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1940)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1940",
    x1: 26.0208,
    y1: 168.078,
    x2: 26.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1940",
    x1: 62.0208,
    y1: 168.078,
    x2: 62.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1940",
    x1: 98.0208,
    y1: 168.078,
    x2: 98.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1940",
    x1: 134.021,
    y1: 168.078,
    x2: 134.021,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1940",
    x1: 240.724,
    y1: 4.34424,
    x2: -37.6865,
    y2: 4.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1940",
    x1: 240.724,
    y1: 63.3442,
    x2: -37.6865,
    y2: 63.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1940",
    x1: 240.724,
    y1: 33.3442,
    x2: -37.6865,
    y2: 33.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1940",
    x1: 52,
    y1: 16.5,
    x2: 54.1764,
    y2: 112.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FBAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703509,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1940",
    x1: 52,
    y1: 16.5,
    x2: 52,
    y2: 88.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFF981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1940"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650635,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness6);
export default __webpack_public_path__ + "static/media/business6.ce41755d3664da460423a6e2358b4354.svg";
export { ForwardRef as ReactComponent };